var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/react/index.ts
var react_exports = {};
__export(react_exports, {
  BlindPick: () => BlindPick_default,
  Firebob1: () => Firebob1_default,
  Firebob10: () => Firebob10_default,
  Firebob11: () => Firebob11_default,
  Firebob12: () => Firebob12_default,
  Firebob13: () => Firebob13_default,
  Firebob14: () => Firebob14_default,
  Firebob15: () => Firebob15_default,
  Firebob16: () => Firebob16_default,
  Firebob17: () => Firebob17_default,
  Firebob18: () => Firebob18_default,
  Firebob2: () => Firebob2_default,
  Firebob3: () => Firebob3_default,
  Firebob4: () => Firebob4_default,
  Firebob5: () => Firebob5_default,
  Firebob6: () => Firebob6_default,
  Firebob7: () => Firebob7_default,
  Firebob8: () => Firebob8_default,
  Firebob9: () => Firebob9_default,
  FirebobDisabled: () => FirebobDisabled_default,
  PlayVsLogo: () => PlayVsLogo_default,
  RegularFirebob: () => RegularFirebob_default
});

// src/react/BlindPick.tsx
import * as React from "react";
function SvgBlindPick(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    fill: "none",
    height: 42,
    viewBox: "0 0 69 42",
    width: 69,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React.createElement("path", {
    d: "M34.72 41.32c2.56 0 4.8-2.24 4.8-4.8 0-2.56-2.24-4.8-4.8-4.8-2.56 0-4.8 2.24-4.8 4.8 0 2.56 2.24 4.8 4.8 4.8Zm-4.8-12.48h8.96c.32-8.64 9.28-8.64 9.28-17.28 0-6.08-5.12-11.2-13.76-11.2-7.68 0-12.8 5.12-13.44 13.12l9.28.64c0-3.52 1.92-5.44 4.16-5.44 2.56 0 4.16 1.6 4.16 3.84 0 4.8-8.64 5.44-8.64 16.32Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M59.441 39.205c1.642 0 3.08-1.436 3.08-3.078 0-1.643-1.438-3.08-3.08-3.08-1.642 0-3.078 1.438-3.078 3.08 0 1.642 1.437 3.078 3.078 3.078Zm-3.078-8.004h5.747c.205-5.542 5.952-5.542 5.952-11.084 0-3.9-3.284-7.184-8.826-7.184-4.926 0-8.21 3.284-8.62 8.416l5.952.41c0-2.258 1.232-3.49 2.668-3.49 1.642 0 2.669 1.027 2.669 2.464 0 3.078-5.542 3.489-5.542 10.468ZM9.441 39.205c1.643 0 3.08-1.436 3.08-3.078 0-1.643-1.438-3.08-3.08-3.08-1.642 0-3.078 1.438-3.078 3.08 0 1.642 1.436 3.078 3.078 3.078Zm-3.078-8.004h5.747c.205-5.542 5.952-5.542 5.952-11.084 0-3.9-3.284-7.184-8.826-7.184-4.926 0-8.21 3.284-8.62 8.416l5.952.41c0-2.258 1.231-3.49 2.668-3.49 1.642 0 2.668 1.027 2.668 2.464 0 3.078-5.541 3.489-5.541 10.468Z",
    fill: "#fff",
    opacity: 0.65
  }));
}
var BlindPick_default = SvgBlindPick;

// src/react/Firebob1.tsx
import * as React2 from "react";
function SvgFirebob1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React2.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React2.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M382 296h38v38h-38zm-185 38h38v38h-38zm223 0h38v38h-38zm-185-38h38v38h-38z",
    fill: "#FF80E8"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M235 408h75v106h-75zm110 0h75v106h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M345 460h41v54h-41zm-110 0h41v54h-41z",
    fill: "#FF80E8"
  }));
}
var Firebob1_default = SvgFirebob1;

// src/react/Firebob10.tsx
import * as React3 from "react";
function SvgFirebob10(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React3.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React3.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#383C3E"
  }), /* @__PURE__ */ React3.createElement("path", {
    clipRule: "evenodd",
    d: "M222 386h-37v19h-17v35h17v18h18v18h19v18h36v-18h19v-18h18v-18h16v-35h-16v-19h-37v19h-36v-19Zm176 0h-37v19h-17v35h17v18h18v18h19v18h36v-18h19v-18h18v-18h16v-35h-16v-19h-37v19h-36v-19Z",
    fill: "#FF230A",
    fillRule: "evenodd"
  }));
}
var Firebob10_default = SvgFirebob10;

// src/react/Firebob11.tsx
import * as React4 from "react";
function SvgFirebob11(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React4.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 765 765",
    width: 765,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React4.createElement("path", {
    d: "M538.622 385.981 661.12 116.746l-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#2970FF"
  }), /* @__PURE__ */ React4.createElement("path", {
    clipRule: "evenodd",
    d: "M558 357.498H96v38h31v50h36v50h110v-100h29v100h113v-50h39v-50h104v-38Z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}
var Firebob11_default = SvgFirebob11;

// src/react/Firebob12.tsx
import * as React5 from "react";
function SvgFirebob12(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React5.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React5.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.491 271.491 0 0 0-75.084 200.047c6.153 139.08 118.866 252.165 257.907 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#383C3E"
  }), /* @__PURE__ */ React5.createElement("path", {
    d: "M383 295h38v38h-38zm-111 38h38v38h-38zm73 0h38v38h-38zm-111-38h38v38h-38z",
    fill: "#FFB3F2"
  }), /* @__PURE__ */ React5.createElement("path", {
    d: "M235 408h75v106h-75zm110 0h75v106h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React5.createElement("path", {
    d: "M345 460h41v54h-41zm-110 0h41v54h-41z",
    fill: "#FFB3F2"
  }));
}
var Firebob12_default = SvgFirebob12;

// src/react/Firebob13.tsx
import * as React6 from "react";
function SvgFirebob13(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React6.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React6.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#FF29D8"
  }), /* @__PURE__ */ React6.createElement("path", {
    d: "M382 296h38v38h-38zm-185 38h38v38h-38zm223 0h38v38h-38zm-185-38h38v38h-38z",
    fill: "#29FFA9"
  }), /* @__PURE__ */ React6.createElement("path", {
    d: "M235 408h75v106h-75zm110 0h75v106h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React6.createElement("path", {
    d: "M345 460h41v54h-41zm-110 0h41v54h-41z",
    fill: "#29FFA9"
  }));
}
var Firebob13_default = SvgFirebob13;

// src/react/Firebob14.tsx
import * as React7 from "react";
function SvgFirebob14(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React7.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 766 765",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React7.createElement("path", {
    d: "m539.124 385.981 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React7.createElement("path", {
    d: "M345 295.498h75v38h-75zm-110 0h75v38h-75z",
    fill: "#FF80E8"
  }), /* @__PURE__ */ React7.createElement("path", {
    d: "M235 372.498h75v141h-75zm110 0h75v141h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React7.createElement("path", {
    d: "M345 459.498h41v54h-41zm-35 80h65v64h-65zm-75-80h41v54h-41z",
    fill: "#FF80E8"
  }));
}
var Firebob14_default = SvgFirebob14;

// src/react/Firebob15.tsx
import * as React8 from "react";
function SvgFirebob15(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React8.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 765 765",
    width: 765,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React8.createElement("path", {
    d: "M538.622 385.981 661.12 116.746l-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#BCC1C2"
  }), /* @__PURE__ */ React8.createElement("path", {
    clipRule: "evenodd",
    d: "M454 532.498h-40v36H271v36h144v-36h39v-36Zm104-175H96v38h31v50h36v50h110v-100h29v100h113v-50h39v-50h104v-38Z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}
var Firebob15_default = SvgFirebob15;

// src/react/Firebob16.tsx
import * as React9 from "react";
function SvgFirebob16(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React9.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React9.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#FF29D8"
  }), /* @__PURE__ */ React9.createElement("path", {
    clipRule: "evenodd",
    d: "M222 386h-37v19h-17v35h17v18h18v18h19v18h36v-18h19v-18h18v-18h16v-35h-16v-19h-37v19h-36v-19Zm176 0h-37v19h-17v35h17v18h18v18h19v18h36v-18h19v-18h18v-18h16v-35h-16v-19h-37v19h-36v-19Z",
    fill: "#fff",
    fillRule: "evenodd"
  }));
}
var Firebob16_default = SvgFirebob16;

// src/react/Firebob17.tsx
import * as React10 from "react";
function SvgFirebob17(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React10.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 765 765",
    width: 765,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React10.createElement("path", {
    d: "M538.622 385.981 661.12 116.746l-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#29FFA9"
  }), /* @__PURE__ */ React10.createElement("path", {
    clipRule: "evenodd",
    d: "M558 357.498H96v38h31v50h36v50h110v-100h29v100h113v-50h39v-50h104v-38Z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}
var Firebob17_default = SvgFirebob17;

// src/react/Firebob18.tsx
import * as React11 from "react";
function SvgFirebob18(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React11.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React11.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.491 271.491 0 0 0-75.084 200.047c6.153 139.08 118.866 252.165 257.907 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#007546"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M383 295h38v38h-38zm-111 38h38v38h-38zm73 0h38v38h-38zm-111-38h38v38h-38z",
    fill: "#FF29D8"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M235 408h75v106h-75zm110 0h75v106h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M345 460h41v54h-41zm-110 0h41v54h-41z",
    fill: "#FF29D8"
  }));
}
var Firebob18_default = SvgFirebob18;

// src/react/Firebob2.tsx
import * as React12 from "react";
function SvgFirebob2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React12.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React12.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#2970FF"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M345 296h75v38h-75zm-110 0h75v38h-75z",
    fill: "#002775"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M235 373h75v141h-75zm110 0h75v141h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M345 460h41v54h-41zm-35 80h65v64h-65zm-75-80h41v54h-41z",
    fill: "#002775"
  }));
}
var Firebob2_default = SvgFirebob2;

// src/react/Firebob3.tsx
import * as React13 from "react";
function SvgFirebob3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React13.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 765 765",
    width: 765,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React13.createElement("path", {
    d: "M538.622 385.981 661.12 116.746l-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#F8FC2B"
  }), /* @__PURE__ */ React13.createElement("path", {
    clipRule: "evenodd",
    d: "M454 532.498h-40v36H271v36h144v-36h39v-36Zm104-175H96v38h31v50h36v50h110v-100h29v100h113v-50h39v-50h104v-38Z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}
var Firebob3_default = SvgFirebob3;

// src/react/Firebob4.tsx
import * as React14 from "react";
function SvgFirebob4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React14.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React14.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#3BEDED"
  }), /* @__PURE__ */ React14.createElement("path", {
    clipRule: "evenodd",
    d: "M222 386h-37v19h-17v35h17v18h18v18h19v18h36v-18h19v-18h18v-18h16v-35h-16v-19h-37v19h-36v-19Zm176 0h-37v19h-17v35h17v18h18v18h19v18h36v-18h19v-18h18v-18h16v-35h-16v-19h-37v19h-36v-19Z",
    fill: "#FF29D8",
    fillRule: "evenodd"
  }));
}
var Firebob4_default = SvgFirebob4;

// src/react/Firebob5.tsx
import * as React15 from "react";
function SvgFirebob5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React15.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 765 765",
    width: 765,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React15.createElement("path", {
    d: "M538.622 385.981 661.12 116.746l-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#FF29D8"
  }), /* @__PURE__ */ React15.createElement("path", {
    clipRule: "evenodd",
    d: "M558 357.498H96v38h31v50h36v50h110v-100h29v100h113v-50h39v-50h104v-38Z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}
var Firebob5_default = SvgFirebob5;

// src/react/Firebob6.tsx
import * as React16 from "react";
function SvgFirebob6(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React16.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React16.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.491 271.491 0 0 0-75.084 200.047c6.153 139.08 118.866 252.165 257.907 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#0049DB"
  }), /* @__PURE__ */ React16.createElement("path", {
    d: "M383 295h38v38h-38zm-111 38h38v38h-38zm73 0h38v38h-38zm-111-38h38v38h-38z",
    fill: "#8AF4F4"
  }), /* @__PURE__ */ React16.createElement("path", {
    d: "M235 408h75v106h-75zm110 0h75v106h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React16.createElement("path", {
    d: "M345 460h41v54h-41zm-110 0h41v54h-41z",
    fill: "#8AF4F4"
  }));
}
var Firebob6_default = SvgFirebob6;

// src/react/Firebob7.tsx
import * as React17 from "react";
function SvgFirebob7(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React17.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React17.createElement("path", {
    d: "m539.124 386.483 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#F8FC2B"
  }), /* @__PURE__ */ React17.createElement("path", {
    d: "M382 296h38v38h-38zm-185 38h38v38h-38zm223 0h38v38h-38zm-185-38h38v38h-38z",
    fill: "#000"
  }), /* @__PURE__ */ React17.createElement("path", {
    d: "M235 408h75v106h-75zm110 0h75v106h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React17.createElement("path", {
    d: "M345 460h41v54h-41zm-110 0h41v54h-41z",
    fill: "#000"
  }));
}
var Firebob7_default = SvgFirebob7;

// src/react/Firebob8.tsx
import * as React18 from "react";
function SvgFirebob8(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React18.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 766 765",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React18.createElement("path", {
    d: "m539.124 385.981 122.498-269.235-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.467 271.467 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#007546"
  }), /* @__PURE__ */ React18.createElement("path", {
    d: "M345 295.498h75v38h-75zm-110 0h75v38h-75z",
    fill: "#FF230A"
  }), /* @__PURE__ */ React18.createElement("path", {
    d: "M235 372.498h75v141h-75zm110 0h75v141h-75z",
    fill: "#fff"
  }), /* @__PURE__ */ React18.createElement("path", {
    d: "M345 459.498h41v54h-41zm-35 80h65v64h-65zm-75-80h41v54h-41z",
    fill: "#FF230A"
  }));
}
var Firebob8_default = SvgFirebob8;

// src/react/Firebob9.tsx
import * as React19 from "react";
function SvgFirebob9(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React19.createElement("svg", __spreadValues({
    fill: "none",
    height: 765,
    viewBox: "0 0 765 765",
    width: 765,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React19.createElement("path", {
    d: "M538.622 385.981 661.12 116.746l-275.133 110.78.195-113.28a271.487 271.487 0 0 0-196.573 83.758 271.473 271.473 0 0 0-75.083 200.047c6.152 139.08 118.865 252.165 257.906 258.805a271.47 271.47 0 0 0 200.334-74.379 271.49 271.49 0 0 0 84.448-196.301l-118.592-.195Z",
    fill: "#3BEDED"
  }), /* @__PURE__ */ React19.createElement("path", {
    clipRule: "evenodd",
    d: "M454 532.498h-40v36H271v36h144v-36h39v-36Zm104-175H96v38h31v50h36v50h110v-100h29v100h113v-50h39v-50h104v-38Z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}
var Firebob9_default = SvgFirebob9;

// src/react/FirebobDisabled.tsx
import * as React20 from "react";
function SvgFirebobDisabled(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React20.createElement("svg", __spreadValues({
    fill: "none",
    height: 54,
    viewBox: "0 0 55 54",
    width: 55,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React20.createElement("path", {
    d: "M27.5 54c14.912 0 27-12.088 27-27S42.412 0 27.5 0 .5 12.088.5 27s12.088 27 27 27Z",
    fill: "#878F92"
  }), /* @__PURE__ */ React20.createElement("path", {
    d: "m44.133 10.752-7.829 17.2h7.575a17.339 17.339 0 1 1-17.3-17.358v7.237l17.553-7.079ZM27.409 34.65v-6.698h-4.797v3.353h2.38v3.345h2.417Zm-7.078 0v-6.698h-4.79v3.353h2.381v3.345h2.409Z",
    fill: "#AFB4B6"
  }), /* @__PURE__ */ React20.createElement("path", {
    d: "M27.409 27.948v6.713h-2.397v-3.356H22.62v-3.357h4.789Zm-7.079 0v6.713h-2.396v-3.356H15.54v-3.357h4.789Z",
    fill: "#fff"
  }));
}
var FirebobDisabled_default = SvgFirebobDisabled;

// src/react/PlayVsLogo.tsx
import * as React21 from "react";
function SvgPlayVsLogo(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React21.createElement("svg", __spreadValues({
    fill: "none",
    height: 22,
    viewBox: "0 0 75 22",
    width: 75,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React21.createElement("g", {
    clipPath: "url(#a)",
    fill: "currentColor"
  }, /* @__PURE__ */ React21.createElement("path", {
    d: "M74.98 12.52c-.04.26-.07.52-.13.77-.28 1.3-1.02 2.28-2.13 2.99-2.11 1.36-5.6 1.46-7.78.21-1.61-.92-2.43-2.34-2.58-4.16-.02-.17 0-.35 0-.54l3.78-.27.03.48c.12.98.67 1.57 1.65 1.75.63.12 1.26.12 1.87-.12.66-.25 1.09-.7 1.17-1.43.04-.4-.08-.76-.41-.97-.42-.26-.87-.5-1.33-.67-1.07-.38-2.16-.68-3.22-1.07-1.04-.38-1.96-.95-2.62-1.88-1.2-1.7-1.35-4.88 1.48-6.63 1.22-.74 2.57-1 3.98-.98 1.26.02 2.46.3 3.52 1.01 1.36.91 2.08 2.2 2.25 3.81.02.19.03.38.04.6l-3.79.27c-.03-.23-.05-.43-.1-.64-.19-.87-.75-1.39-1.68-1.5-.75-.09-1.46.03-2.02.61-.66.68-.57 1.53.27 1.94.66.32 1.37.54 2.07.76 1.03.32 2.07.6 3.03 1.12 1.6.86 2.51 2.15 2.59 4 0 .04.03.08.04.12v.42h.02Zm-71.05-.73v5.41H0V.14h6.78c2.91 0 5.33 1.98 5.85 4.74.58 3.11-1.35 6.05-4.44 6.74-.49.11-1.01.15-1.51.17-.9.03-1.81 0-2.75 0Zm0-3.82c.06 0 .11.02.15.02.88 0 1.76.01 2.64 0 1.09-.02 2.03-.9 2.06-1.91.03-1.11-.79-2.04-1.93-2.11-.94-.05-1.88-.02-2.82-.02-.03 0-.06.02-.1.03v3.99ZM62.16.14c-1.95 5.72-3.89 11.39-5.83 17.08h-3.82c-.19 0-.27-.05-.33-.23l-2.4-7.05c-1.09-3.2-2.18-6.4-3.28-9.6-.02-.05-.03-.1-.05-.19.09 0 .18-.02.26-.02h3.56c.19 0 .27.06.33.25 1.18 3.7 2.37 7.39 3.56 11.08.04.11.08.23.15.41.11-.34.21-.62.3-.9L58 .41c.07-.21.15-.29.38-.28 1.16.01 2.32 0 3.48 0h.31l-.01.01Zm-33.08 5.8c.16-.37.31-.7.47-1.04.03-.07.12-.15.18-.15h2.59v12.47h-2.51c-.15 0-.22-.05-.27-.18-.14-.34-.3-.67-.44-1.01-.33.22-.62.46-.95.64-2.04 1.14-4.59.82-6.33-.8-1.54-1.43-2.16-3.23-2.06-5.3.08-1.67.69-3.13 1.88-4.32 2.03-2.03 5.06-2.21 7.31-.43.04.03.08.06.15.12h-.02Zm-.27 4.96c-.02-.17-.03-.43-.08-.67-.23-1.02-.8-1.78-1.82-2.1-.96-.3-1.86-.12-2.59.59-.83.8-1.03 1.81-.85 2.91.3 1.88 2.3 2.91 3.92 1.99 1.01-.57 1.4-1.51 1.43-2.71l-.01-.01Zm4.62-6.15h3.8c.18 0 .19.12.23.23.68 1.95 1.37 3.89 2.05 5.84.18.52.36 1.04.57 1.62.21-.6.4-1.13.59-1.67.68-1.93 1.35-3.86 2.03-5.79.04-.12.07-.24.26-.23 1.21.01 2.43 0 3.64 0 .03 0 .05 0 .09.02 0 .04 0 .09-.02.12-1.73 4.29-3.46 8.59-5.19 12.87-.34.83-.77 1.62-1.33 2.33-.95 1.21-2.2 1.7-3.71 1.58-.27-.02-.54-.07-.82-.1v-3.12c.28-.04.54-.06.8-.11.88-.17 1.4-.75 1.71-1.55.03-.09 0-.22-.04-.32C36.73 13.03 35.36 9.6 34 6.16c-.18-.46-.36-.91-.56-1.41h-.01ZM17.84 17.21H14.2V.16h3.64v17.05Z"
  })), /* @__PURE__ */ React21.createElement("defs", null, /* @__PURE__ */ React21.createElement("clipPath", {
    id: "a"
  }, /* @__PURE__ */ React21.createElement("path", {
    d: "M0 0h74.98v21.69H0z",
    fill: "#fff"
  }))));
}
var PlayVsLogo_default = SvgPlayVsLogo;

// src/react/RegularFirebob.tsx
import * as React22 from "react";
function SvgRegularFirebob(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React22.createElement("svg", __spreadValues({
    fill: "none",
    height: 766,
    viewBox: "0 0 766 766",
    width: 766,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React22.createElement("path", {
    d: "M539.631 386.99 662.13 117.755l-275.134 110.78.196-113.28a271.489 271.489 0 0 0-196.573 83.758 271.476 271.476 0 0 0-75.084 200.047c6.152 139.08 118.866 252.165 257.907 258.805a271.472 271.472 0 0 0 200.333-74.378 271.475 271.475 0 0 0 84.448-196.302l-118.592-.195ZM400.414 492.067h-37.558V439.47h-37.46v-52.539h75.018v105.136Zm-110.819 0h-37.616V439.47h-37.402v-52.539h74.94l.078 105.136Z",
    fill: "#FF5509"
  }));
}
var RegularFirebob_default = SvgRegularFirebob;

// src/NxRandomFirebobHover.tsx
import { Box, makeStyles } from "@material-ui/core";
import React23, { useState, useMemo } from "react";
var DISABLED_FIREBOBS = ["RegularFirebob", "FirebobDisabled"];
var useStyles = makeStyles(() => ({
  baseFirebob: ({
    isHovered
  }) => ({
    position: "fixed",
    opacity: isHovered ? "0" : "1",
    transition: "all 0.4s ease-in-out",
    zIndex: 29
  }),
  hoveredFirebob: ({
    isHovered
  }) => ({
    position: "fixed",
    opacity: isHovered ? "1" : "0",
    transform: isHovered ? "scale(1.2)" : "scale(1)",
    transition: "all 0.4s ease-in-out",
    zIndex: 30
  })
}));
function NxRandomFirebobHover(_a) {
  var _b = _a, {
    overrideHover,
    isHovered
  } = _b, rest = __objRest(_b, [
    "overrideHover",
    "isHovered"
  ]);
  const [hovered, setHovered] = useState(false);
  const [randomizedNumber, setRandomizedNumber] = useState(0);
  const hoverOverride = overrideHover ? isHovered : hovered;
  const classes = useStyles({ isHovered: hoverOverride });
  const randomFirebobs = useMemo(() => Object.entries(react_exports).filter((firebob) => {
    const assetName = firebob[0];
    return !DISABLED_FIREBOBS.some((fireName) => fireName === assetName) && assetName.toLowerCase().includes("firebob");
  }), [react_exports]);
  React23.useEffect(() => {
    if (!hoverOverride) {
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * randomFirebobs.length);
        setRandomizedNumber(randomIndex);
      }, 400);
    }
  }, [hoverOverride]);
  const RandomFirebobHover = randomFirebobs[randomizedNumber][1];
  const toggleHover = () => {
    if (!overrideHover) {
      setHovered(!hovered);
    }
  };
  return /* @__PURE__ */ React23.createElement(Box, {
    onMouseEnter: toggleHover,
    onMouseLeave: toggleHover
  }, /* @__PURE__ */ React23.createElement(RandomFirebobHover, __spreadValues({
    className: classes.hoveredFirebob
  }, rest)), /* @__PURE__ */ React23.createElement(RegularFirebob_default, __spreadValues({
    className: classes.baseFirebob
  }, rest)));
}
export {
  react_exports as NxMiscAssets,
  NxRandomFirebobHover
};
//# sourceMappingURL=index.js.map